import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CmsConfig, I18nModule, provideDefaultConfig} from '@spartacus/core';
import {TooltipModule} from 'ng-design-system';
import {DcpConfiguratorPriceSummaryComponent} from './dcp-configurator-price-summary.component';
import {DcpDateFormatterModule} from '../../pipes';
import {GroupSkipDirective} from '@dcp/accessibility';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    I18nModule,
    TooltipModule,
    DcpDateFormatterModule,
    GroupSkipDirective,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        ConfiguratorPriceSummary: {
          component: DcpConfiguratorPriceSummaryComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [DcpConfiguratorPriceSummaryComponent],
  exports: [DcpConfiguratorPriceSummaryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DcpConfiguratorPriceSummaryModule {}
